import type { Trait } from './types.js';

/**
 * Ordem de coleta da Estacao 3: um instrumento por vez. O medidor pega o
 * hipometro e faz todas as alturas, depois o compasso, a fita, o goniometro, e
 * termina com os aprumos, que sao visuais. Trocar de instrumento a cada medida
 * e o que faz o app perder do papel em tempo.
 *
 * Fica fora da spec (nao muda o hash): e como o formulario se apresenta, nao o
 * que o protocolo exige.
 */
export interface GrupoDeColeta {
  id: string;
  rotulo: string;
  traits: Trait[];
}

const ORDEM: ReadonlyArray<{ id: string; rotulo: string; pega: (t: Trait) => boolean }> = [
  { id: 'hipometro', rotulo: 'Hipômetro', pega: (t) => t.instrument === 'hipometro' },
  { id: 'compasso', rotulo: 'Compasso', pega: (t) => t.instrument === 'compasso' },
  { id: 'fita', rotulo: 'Fita', pega: (t) => t.instrument === 'fita' },
  { id: 'goniometro', rotulo: 'Goniômetro', pega: (t) => t.instrument === 'goniometro' },
  { id: 'aprumos', rotulo: 'Aprumos', pega: (t) => t.kind === 'aprumo' },
];

/** Os traits do nivel, agrupados por instrumento e, dentro do grupo, na ordem da ficha. */
export function gruposDeColeta(traits: readonly Trait[], nivel: number): GrupoDeColeta[] {
  const doNivel = traits.filter((t) => t.levelMin <= nivel).sort((a, b) => a.sortOrder - b.sortOrder);
  const vistos = new Set<Trait>();
  const grupos: GrupoDeColeta[] = [];
  for (const g of ORDEM) {
    const doGrupo = doNivel.filter((t) => !vistos.has(t) && g.pega(t));
    doGrupo.forEach((t) => vistos.add(t));
    if (doGrupo.length) grupos.push({ id: g.id, rotulo: g.rotulo, traits: doGrupo });
  }
  // Rede de seguranca: um trait novo sem instrumento conhecido nao some da tela.
  const resto = doNivel.filter((t) => !vistos.has(t));
  return resto.length ? [...grupos, { id: 'outros', rotulo: 'Outras', traits: resto }] : grupos;
}
